export default __webpack_public_path__ + "static/media/sponsor_5.4e0461c3.png";